import { render, staticRenderFns } from "./ServiceSetup.vue?vue&type=template&id=ef55e292&"
import script from "./ServiceSetup.vue?vue&type=script&lang=js&"
export * from "./ServiceSetup.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSetup.vue?vue&type=style&index=0&id=ef55e292&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports